import { ProjectFragmentFragment } from '@lopo-tech/lopo-api'
import React from 'react'
import { ConstructionStatusTag } from 'src/components/projects/construction_status_tag/construction_status_tag'
import { Tag } from 'src/components/tag/tag'
import { CLASS_PREFIX } from 'src/constants'
import './project_detail_hero.scss'

const cls = `${CLASS_PREFIX}project-detail-hero`

type Props = {
  tags: ProjectFragmentFragment['tags'];
  canShowTags: ProjectFragmentFragment['canShowTags'];
  constructionStatus: ProjectFragmentFragment['constructionStatus'];
  slug: string;
  name: string;
  imageUrl?: string;
};

export const ProjectDetailHero: React.FC<Props> = ({
  canShowTags,
  tags,
  constructionStatus,
  name,
  imageUrl
}) => {
  return (
    <div className={cls}>
      {/* share function is not working properly across browsers and operating systems
      <button
        className={`${cls}__share`}
        onClick={nativeShare(UrlUtils.detailPage(slug, 'Project'), 'utmSource')}
      >
        <Icon name="share-thick" size={20} color={COLOR_TYPE_PRIMARY} />
        <span>{t.details.shareProject}</span>
      </button> */}

      <div className={`${cls}__hero-image`}>
        {imageUrl && <img src={imageUrl} alt="" loading="lazy" />}
      </div>

      <div className={`${cls}__hero-overlay`}>
        <h1 className={`${cls}__hero-title`}>{name}</h1>

        <ConstructionStatusTag status={constructionStatus} />

        {canShowTags && !!tags?.length && (
          <div className={`${cls}__tags`}>
            {tags.map((tag) => (
              <Tag key={tag.id} text={tag.name} gradient />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
